"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTMSubscriptionMessage = exports.RTMMessageResponse = void 0;
/**
 * Represents a response from the server.
 */
class RTMMessageResponse {
    data;
    id;
    constructor(rawMessage) {
        const _msg = JSON.parse(rawMessage);
        this.data = _msg.data;
        this.id = _msg.id;
    }
}
exports.RTMMessageResponse = RTMMessageResponse;
class RTMSubscriptionMessage {
    data;
    event;
    constructor(raw) {
        this.data = raw.data;
        this.event = raw.event;
    }
}
exports.RTMSubscriptionMessage = RTMSubscriptionMessage;
